export const LIGHT = "LIGHT";
export const DARK = "DARK";

export type ThemeStore = {
  mode: typeof LIGHT | typeof DARK;
};
